import { render } from "./SoundDesign.vue?vue&type=template&id=21f6f3b2"
import script from "./SoundDesign.vue?vue&type=script&lang=js"
export * from "./SoundDesign.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__